
<template>
  <hvh-chart :visualization="visualization" :options="chartOptions" :height="height" @dataCreated="chartDataCreated" @item-clicked="itemClicked" />
</template>

<script>
import { merge } from 'lodash';
export default {
  noExport: true,
  props: ['chartData', 'options', 'height'],
  methods: {
    chartDataCreated: function (data) {
      this.$emit('data-created', data);
    },
    itemClicked(index, data) {
      this.$emit('checked-changed', index, data);
    },
  },
  computed: {
    visualization: function () {
      var dat = {};
      for (var i = 0; i < this.chartData.datasets.length; i++) {
        var dataset = this.chartData.datasets[i];
        dat[dataset.label] = dataset.data;
      }

      return {
        visualization_type: 'linechart',
        lineChartType: this.chartData.lineChartType,
        labels: this.chartData.labels,
        colors: this.chartData.colors,
        symbols: this.chartData.symbols,
        data: dat,
        tooltip: this.options.tooltip,
      }
    },
    chartOptions: function () {
      return merge({
        xAxis: {
          type: this.visualization.lineChartType,
        },
        yAxis: {
          nameTextStyle: {
            fontSize: 15
          },
          nameGap: 60
        }
      }, this.options);
    },
  },
  mounted() {
    if (process.env.NODE_ENV === 'development') window['thisLineChart'] = this;
  },
}
</script>